import { type FC } from "react";

import { Check } from "lucide-react";

import documentCheckmarkImg from "@/shared/assets/illustrations/document-checkmark.svg";

import { HeroCard } from "./HeroCard";

interface SetupStep {
  label: string;
  completed: boolean;
}

interface SetupHeroCardProps {
  steps: SetupStep[];
  remainingCount: number;
  onFinishSetup: () => void;
}

export const SetupHeroCard: FC<SetupHeroCardProps> = ({ steps, remainingCount, onFinishSetup }) => {
  if (remainingCount === 0) return null;

  return (
    <HeroCard
      bgColor="bg-yellow-50"
      illustration={documentCheckmarkImg}
      title={`Your roadmap is ${remainingCount} step${remainingCount !== 1 ? "s" : ""} away`}
      description="Some estates need court approval and some don't. Answer a few questions, and your roadmap is built around your answers."
      ctaLabel="Finish setup"
      ctaSubtext="Free · About 3 minutes"
      onCtaClick={onFinishSetup}
    >
      <div className="flex flex-col gap-2">
        {steps.map((step) => (
          <div key={step.label} className="flex items-center gap-3">
            {step.completed ? (
              <div className="size-6 shrink-0 flex items-center justify-center">
                <Check className="size-6 text-brand" strokeWidth={2} />
              </div>
            ) : (
              <div className="size-5 shrink-0 rounded border border-primary" />
            )}
            <span className="text-sm text-secondary tracking-[-0.02em]">{step.label}</span>
          </div>
        ))}
      </div>
    </HeroCard>
  );
};
